import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalInfo } from 'src/app/models';

@Component({
    selector: 'app-delete-modal',
    templateUrl: './delete-modal.component.html',
    styleUrls: ['./delete-modal.component.scss'],
    standalone: false
})
export class DeleteModalComponent implements OnInit {

  @Input() data: ModalInfo;
  @Output() delete: EventEmitter<ModalInfo> = new EventEmitter();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() { }

  /**
   * Metodh to pass data to delete item to favourites-section component
   */

  async deleteItem() {
    this.delete.emit(this.data);
    this.activeModal.close();
  }

  /**
   * Close modal
   */

  onDelete() {
    this.activeModal.close();
  }

}
